import axios from 'axios';
import { usersHost } from '../urls/api-users/admin';
import { getCurrentAuth0Id } from './paymentService';
import { isProductionStage } from '../utils/environmentMode';

const THEME_PREFERENCE_ENDPOINT = usersHost + '/users/theme-preference';
const VALID_THEME_MODES = ['light', 'dark'];
const isThemePreferenceFeatureEnabled = process.env.REACT_APP_ENABLE_THEME_PREFERENCE === 'true';

const isLocalDashboard = () =>
    typeof window !== 'undefined' &&
    window.location &&
    (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

const isValidThemeMode = themeMode => VALID_THEME_MODES.includes(themeMode);

const shouldUseRemoteThemePreference = () => {
    if (isLocalDashboard()) {
        return false;
    }

    if (isThemePreferenceFeatureEnabled) {
        return true;
    }

    return isProductionStage();
};

const getAccessToken = () => {
    if (typeof window === 'undefined') {
        return null;
    }

    return window.localStorage.getItem('access_token');
};

const getAuthHeaders = () => {
    const accessToken = getAccessToken();

    if (!accessToken) {
        return null;
    }

    return {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + accessToken,
    };
};

const extractThemeMode = responseData => {
    const payload = responseData && responseData.payload ? responseData.payload : null;
    const themeMode = payload && payload.theme_mode;

    return isValidThemeMode(themeMode) ? themeMode : null;
};

export const getSignedInThemePreferenceUserId = () => getCurrentAuth0Id();

export const hasSignedInThemePreferenceUser = () => Boolean(getSignedInThemePreferenceUserId() && getAccessToken());

export const fetchThemePreference = async () => {
    if (!shouldUseRemoteThemePreference()) {
        return null;
    }

    const headers = getAuthHeaders();

    if (!headers || !hasSignedInThemePreferenceUser()) {
        return null;
    }

    const response = await axios.get(THEME_PREFERENCE_ENDPOINT, {
        headers,
    });

    return extractThemeMode(response.data);
};

export const persistThemePreference = async themeMode => {
    if (!shouldUseRemoteThemePreference()) {
        return themeMode;
    }

    const headers = getAuthHeaders();

    if (!headers || !hasSignedInThemePreferenceUser() || !isValidThemeMode(themeMode)) {
        return null;
    }

    const response = await axios.patch(
        THEME_PREFERENCE_ENDPOINT,
        {
            theme_mode: themeMode,
        },
        {
            headers,
        }
    );

    return extractThemeMode(response.data) || themeMode;
};